module.exports = __webpack_public_path__ + "img/GO.6b7e52c6.png";